const LoadingDots = () => {
  return (
    <span>
      <span />
      <span />
      <span />
    </span>
  )
}

export default LoadingDots
